import styled from 'styled-components'

import e2eClass from 'helpers/automation'

export const FieldContainer = styled.div.attrs(props => ({
  className: `${props.e2eClass}-${props.fieldId}`
}))`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 0;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.dustyGray};
  font-size: 14px;

  ${({ theme, tabIndex }) =>
    tabIndex === 0 &&
    `
      border-radius: 3px;
      border: solid 1px ${theme.colors.grayLight};
      outline: 0;
      padding: 10px 15px;

      &:focus-within {
        border-color: ${theme.colors.blue};
        box-shadow: 0 2px 4px 0 ${theme.shadow.black10};
        color: ${theme.colors.blue};
      }
    `};

  ${({ theme, border }) =>
    border &&
    `
      border-bottom: solid 1px ${theme.colors.silver};
      &:last-child {
        border-bottom: none;
      }
    `};
`

export const InputField = styled.div.attrs(() => ({
  className: e2eClass('ancillaries.inputValue')
}))`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  color: ${({ theme }) => theme.colors.accessibleGrey};
`
